"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _TransmuteCollection = require("./TransmuteCollection");

_TransmuteCollection.map.implement(Array, function (mapper, arr) {
  return arr.map(mapper);
});

_TransmuteCollection.map.implementInherited(_immutable.Iterable, function (mapper, iter) {
  return iter.map(mapper);
});

_TransmuteCollection.map.implement(Object, function (mapper, obj) {
  var result = {};
  var keys = Object.keys(obj);
  var len = keys.length;

  for (var i = 0; i < len; i++) {
    var key = keys[i];
    result[key] = mapper(obj[key], key, obj);
  }

  return result;
});

var _default = _TransmuteCollection.map;
exports.default = _default;
module.exports = exports.default;